export const RECEIVE_ONBOARDING_ALERT = 'RECEIVE_ONBOARDING_ALERT';
